import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useDispatch } from 'react-redux';

const CollectionCard = ({ collection }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Get first product image or use placeholder
  const collectionImage = collection.products && collection.products.length > 0 
    ? collection.products[0].img[0] 
    : null;

  const handleClick = (e) => {
    e.preventDefault();
    // Navigate to products page with collection filter
    navigate(`/products?collection=${collection.value}`);
  };

  return (
    <motion.article
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className="group"
    >
      <Link
        to={`/products?collection=${collection.value}`}
        onClick={handleClick}
        className="block"
      >
        {/* Image Container */}
        <div className="relative aspect-[4/5] bg-stone-100 overflow-hidden mb-4">
          {collectionImage ? (
            <img 
              src={collectionImage} 
              alt={collection.name}
              className="absolute inset-0 w-full h-full object-contain p-8 group-hover:scale-105 transition-transform duration-500"
            />
          ) : (
            <div className="absolute inset-0 bg-gradient-to-br from-emerald-50/50 to-stone-50 flex items-center justify-center">
              <span className="text-7xl opacity-10">{collection.icon}</span>
            </div>
          )}
          
          {/* Product Count Badge */}
          <div className="absolute top-3 right-3 px-2.5 py-1 bg-white/95 text-xs font-medium text-stone-700">
            {collection.productCount} Products
          </div>

          {/* Hover Overlay */}
          <div className="absolute inset-0 bg-emerald-900/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        </div>

        {/* Content */}
        <div className="space-y-2">
          <h3 className="text-lg font-medium text-stone-900 group-hover:text-emerald-700 transition-colors duration-300">
            {collection.name}
          </h3>
          <p className="text-sm text-stone-600 leading-relaxed line-clamp-2">
            {collection.description}
          </p>
          <div className="flex items-center text-sm font-medium text-emerald-700 pt-1">
            <span className="relative after:absolute after:bottom-0 after:left-0 after:h-px after:w-0 after:bg-emerald-700 after:transition-all after:duration-300 group-hover:after:w-full">
              View Collection
            </span>
            <svg className="w-4 h-4 ml-1 transform group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </div>
        </div>
      </Link>
    </motion.article>
  );
};

export default CollectionCard;
